import React from "react";
import { Layout, Row, Col, Typography } from "antd";
import NavBar from "components/nav-bar";
import { FooterBar } from "components/footer";

import "./contact.less";
import pattern from "assets/pattern.svg";
import contactImg from "assets/contact.png";

class Contact extends React.Component {
  render() {
    return (
      <Layout className='page--contact'>
        <NavBar />
        <Row className='content__container'>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}>
            <div className='pattern-background' style={{backgroundImage: `linear-gradient(to right, rgba(16, 11, 2, 0.88), rgba(16, 11, 2, 1)), url(${pattern})`}} />
          </Col>

          <Col xs={22} sm={22} md={20} lg={18} xl={16} xxl={14}>
            <Row>
              <Typography.Title className='content__title'>Connect with us</Typography.Title>
            </Row>

            <Row>
              <img src={contactImg} alt='' className='contact__image' />
            </Row>

            <Row>
              <Typography.Title level={4} className='contact__description'>We'd love to partner, interact, join hands, or just have a chat with you! We're open to a great conversation over good coffee.</Typography.Title>
            </Row>

            <Row>
              <Typography.Title level={4} className='contact__email'>Reach out to us on connect@nowd.org</Typography.Title>
            </Row>
          </Col>
          <Col xs={1} sm={1} md={2} lg={3} xl={4} xxl={5}>
            <div className='pattern-background' style={{backgroundImage: `linear-gradient(to left, rgba(16, 11, 2, 0.88), rgba(16, 11, 2, 1)), url(${pattern})`}} />
          </Col>
        </Row>

        <FooterBar />
      </Layout>
    );
  }
}

export default Contact;
